import React from 'react';
import NavItem from 'components/navigation/NavItem';
import { NavMain, NavComparison, NavTable, HamburgerButton, CloseBtn } from 'components/lib/buttons/IconButtons';
import styles from 'styles/components/navigation/navBar.css';
import Constants from 'utils/Constants';
// blue color #099BFA

const NavBar = (props) => {
  let selectedStyle = {
    backgroundColor: 'rgba(9, 155, 250, 0.05)',
    borderRight: '2px solid #099BFA',
    paddingLeft: '10px'
  }
  let regStyle = {
    paddingLeft: '10px'
  }
  return [
    <div key="overlay"
         onClick={props.closeNavBar}
         className={props.navBarOpen ? styles.overlay : null}/>,

    <div key="navbar"
         onBlur={props.closeNavBar}
         className={styles[props.navBarClass]} >
      <div className={styles.sectionIcons}>
        <div className={styles.iconLine}
             style={{padding: '20px 0px 20px 10px', justifyContent: props.navBarOpen ? 'flex-end' : 'flex-start'}}>
          { props.navBarOpen ? (
              <CloseBtn onClick={props.toggleNavBar} />
            ) : (
              <HamburgerButton onClick={props.toggleNavBar} />
            )
          }
        </div>
        <NavItem key={"revenue"}
          changeView={() => { props.changeView('main') }}
          itemType="main"
          label="Series Revenue"
          navBarOpen={props.navBarOpen}
          selectedView={props.selectedView} />
        <NavItem key={"comparison"}
          changeView={() => { props.changeView('comparison') }}
          itemType="comparison"
          label="Series Comparison"
          navBarOpen={props.navBarOpen}
          selectedView={props.selectedView} />
        <NavItem key={"dailyReport"}
          changeView={() => { props.changeView('table') }}
          itemType="table"
          label="Daily Report Builder"
          navBarOpen={props.navBarOpen}
          selectedView={props.selectedView} />
      </div>
    </div>
  ];
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/scripts/components/navigation/NavBar.js